// Build version: 2026-03-26-v2 - Login error fix deployed
import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";

// Suppress ResizeObserver loop error - this is a benign browser warning
// that occurs with dynamic UI components (dropdowns, modals, etc.)
// See: https://github.com/WICG/resize-observer/issues/38
const resizeObserverErr = window.onerror;
window.onerror = (message, source, lineno, colno, error) => {
  if (message === 'ResizeObserver loop completed with undelivered notifications.') {
    return true; // Suppress error
  }
  return resizeObserverErr ? resizeObserverErr(message, source, lineno, colno, error) : false;
};

// Also handle it in error events
window.addEventListener('error', (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>,
);
